// B(10/31 대표님 P4): 기존 예약 사이트(bs·kpv·pj) 방문 집계 — 스토어·매장 홈페이지와 같은 곳(쿠폰 앱 /api/crm/visit)에 보냄.
// 하루에 기기당 1번(무작위 기기 id, 개인정보 아님) · 유입 경로: ?ref=(링커스)·?bm=(브랜드 메시지)·utm_source/?src=·바깥 주소 호스트.
// crm 매장 id(쿠폰 앱 매장 신청 id, /api/crm/site?store=bsv|kpv|pj 의 store.id): 부산·김포·파주. 실패해도 화면에는 영향 없음.
// 미리 묻는 요청(CORS preflight)이 쿠폰 앱에서 막혀 본문은 text/plain으로 보냄(서버는 본문을 JSON으로 읽음).
const COUPON_API = "https://coupon.amzinfra.site";
const STORE_BY_SITE = { bs: "ap-mvaubb36-21a1e6", kpv: "ap-mvah9gso-d031e0", pj: "ap-mvah9gbl-f9e102" };
const VID_KEY = "amazing-legacy:vid:v1";

function deviceId() {
  try {
    let id = localStorage.getItem(VID_KEY);
    if (!id) {
      id = (crypto.randomUUID?.() ?? `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
      localStorage.setItem(VID_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}

export function storeForHost(hostname) {
  const m = /^([a-z0-9-]+)\.(amzvillage|amazingticket)\.site$/.exec(String(hostname || "").toLowerCase());
  return m ? STORE_BY_SITE[m[1]] || "" : "";
}

export function visitSource(search, referrer, hostname) {
  const q = new URLSearchParams(search || "");
  const out = {};
  const ref = q.get("ref");
  const bm = q.get("bm");
  const src = q.get("utm_source") || q.get("src");
  if (ref) out.ref = ref.slice(0, 20);
  if (bm) out.bm = bm.slice(0, 24);
  if (src) out.src = src.slice(0, 40);
  try {
    const rh = referrer ? new URL(referrer).hostname : "";
    if (rh && rh !== hostname && !/\.(amzvillage|amazingticket)\.site$/.test(rh)) out.rf = rh;
  } catch {
    // 잘못된 referrer는 무시
  }
  return out;
}

export function pingLegacyVisit() {
  const store = storeForHost(window.location.hostname);
  if (!store) return;
  const vid = deviceId();
  if (!vid) return;
  const day = new Date(Date.now() + 9 * 3600000).toISOString().slice(0, 10);
  const key = `amazing-legacy:visit:${store}:${day}`;
  try {
    if (localStorage.getItem(key)) return;
    localStorage.setItem(key, "1");
  } catch {
    // 저장소를 못 쓰면 그냥 보냄(서버가 하루 기기당 1번으로 셈)
  }
  const body = { store, vid, ...visitSource(window.location.search, document.referrer, window.location.hostname) };
  fetch(`${COUPON_API}/api/crm/visit`, {
    method: "POST",
    headers: { "Content-Type": "text/plain;charset=UTF-8" },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => undefined);
}
